import { makeStyles, Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { i18n } from 'translate/i18n';
import errorImg from '../../assets/images/errorImage.jpeg'
import errorVideo from '../../assets/images/errorVideo.jpg'
import errorAudio from '../../assets/images/errorAudio.png'

// import { Container } from './styles';

function FileTreatment({ src, type, className, alt, onPress, height, width, controls, style, controlsList, position }) {
    const [errorText, setErrorText] = useState(0);
    const [error, setError] = useState(false);


    const onImgError = (e) => {
        setError(true);
        if(type === 1) {
            e.target.src = errorImg;
        }
    }

    let useStyles = makeStyles((theme) => ({
        customWidth: {
          fontSize: 16,
        },
    }));

    const classes = useStyles();


    //TYPE 1 =  IMAGE
    //TYPE 2 = FILE
    //TYPE 3 = AUDIO

    useEffect(() => {
        //ERROR TO SHOW IN TOOLTIP
        if(type === 1) {
            setErrorText(i18n.t('errorImage'));
        } else if (type === 2) {
            setErrorText(i18n.t('errorVideo'));
        } else if (type === 3) {
            setErrorText(i18n.t('errorAudio'));
        }   else if (type === 4) {
            setErrorText(i18n.t('errorFile'));
        }
    }, [type]);

    return (
        <>

            {
                type === 1 ?
                <>
                {!error ?
                    <img
                        height={height}
                        width={width}
                        alt={alt}
                        style={style}
                        onError={(e) => {onImgError(e)}}
                        className={className}
                        src={src}
                        onClick={() => !error && onPress && onPress()}
                    />
                :

                    <Tooltip
                        arrow
                        placement="left"
                        classes={{tooltip: classes.customWidth}}
                        title={errorText}
                    >
                         <img
                            height={height}
                            style={style}
                            width={width}
                            alt={alt}
                            className={className}
                            src={errorImg}
                        />
                    </Tooltip>
                }

                </>
                : type === 2 ?
                <>
                {!error ?
                    <video
                        height={height}
                        width={width}
                        alt={alt}
                        onError={onImgError}
                        className={className}
                        src={src}
                        controls={controls}
                        style={style}
                        controlsList={controlsList}
                    />
                :
                    <Tooltip
                        arrow
                        placement="top"
                        classes={{tooltip: classes.customWidth}}
                        title={errorText}
                    >
                        <img
                            height={height}
                            width={width}
                            style={style}
                            alt={alt}
                            className={className}
                            src={errorVideo}
                        />
                    </Tooltip>
                }
                </>
                : type === 3 &&
                <>
                    {!error ?
                        <audio
                            controls={controls}
                            style={style}
                            onError={onImgError}
                            controlsList={controlsList}
                            src={src}
                        />
                    :
                        <Tooltip
                            arrow
                            placement="top"
                            classes={{tooltip: classes.customWidth}}
                            title={errorText}
                        >
                            <img
                                height={50}
                                width={'100%'}
                                alt={alt}
                                className={className}
                                src={errorAudio}
                            />
                        </Tooltip>
                    }
                </>
            }
        </>
    );
}

export default FileTreatment;
